export const isDoubleDpc = false;

export const isBackToDpc = false;